import type { PhcPlatformRestEndpoints } from '@lifeomic/phc-web-toolkit/src/hooks/useRestAPIHooks';

export type {
  RegenerativeMedicineCenterLocation,
  RegenerativeMedicineConsentForm,
  RegenerativeMedicineLifecycleState,
  RegenerativeMedicineProvenanceStatus,
  RegenerativeMedicineProvenance,
  RegenerativeMedicinePipelineRow,
  RegenerativeMedicinePipelineResponse,
  RegenerativeMedicineEvidence,
  RegenerativeMedicineMemberDetail,
} from '@lifeomic/phc-web-toolkit/src/types/regenerativeMedicineRestEndpoints';

export type RegenerativeMedicinePipelineQuery =
  PhcPlatformRestEndpoints['GET /v1/member-operations/regenerative-medicine/pipeline']['Request'];

export const LIFECYCLE_STATES = [
  'interest_flagged',
  'consult_scheduled',
  'consult_completed',
  'consent_complete',
  'procedure_documented',
  'revenue_captured',
  'post_procedure_followups',
  'not_assessed',
] as const;

export const LIFECYCLE_STEP_ORDER = [
  'interest_flagged',
  'consult_scheduled',
  'consult_completed',
  'consent_complete',
  'procedure_documented',
  'revenue_captured',
  'post_procedure_followups',
] as const;

export const CENTER_LOCATION_OPTIONS = [
  { value: 'naples_fl', label: 'Naples FL' },
  { value: 'orlando_fl', label: 'Orlando FL' },
  { value: 'dallas_tx', label: 'Dallas TX' },
  { value: 'houston_tx', label: 'Houston TX' },
  { value: 'westchester_ny', label: 'Westchester NY' },
] as const;

export const CONSENT_FORM_OPTIONS = [
  { value: 'pda_002', label: 'PDA-002' },
  { value: 'pda_001', label: 'PDA-001' },
  { value: 'tpe', label: 'TPE' },
] as const;
